import httpClient from '@/http-client'

export default {
  get() {
    return httpClient
      .get('/api/languages')
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
  }
}
